const tabsRootContextKey = Symbol("tabsRootContextKey");

export { tabsRootContextKey };
//# sourceMappingURL=constants.mjs.map
